module.exports = __webpack_public_path__ + "static/media/facade_washington.166d4220.jpg";